import { Checkbox } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { formatPrice } from "../../Functions/Price";

const CartStyle = styled.div`
    --n-primary-2: #0E3D5C;
    --n-grey-2: #E5E5E5;
    --n-grey-3: #CBCBCB;
    --n-grey-6: #D1D1D6;
    --n-grey-7: #979797;
    --n-grey-9: #5E5E5E;

    position: relative;
    display: flex;
    justify-content: space-between;
    background-color: var(--body-2);
    box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    min-height: 150px;
    flex-grow: 1;
    text-decoration: none;
    color: inherit;
    padding: 0.75rem;
    .selector {
        min-width: 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 0.75rem 0 1.5rem;
        .button {
            display: flex;
            align-items: center;
            border: 1px solid var(--n-grey-2);
            border-radius: 4px;
            .goods-checkbox {
                color: var(--n-grey-6);
                .MuiSvgIcon-root{
                    font-size: 32px;
                    border-width: 1px;
                }
            }
            label {
                color: var(--n-grey-7);
                padding-left: 16px;
                font-size: 0.8rem;
                height: 50px;
                display: flex;
                align-items: center;
            }
            &.active {
                border: 1px solid var(--n-primary-2);
                .goods-checkbox {
                    color: var(--n-primary-2);
                    .MuiSvgIcon-root{
                        font-size: 32px;
                        border-width: 1px;
                    }
                }
                label {
                    color: var(--n-grey-9);
                    padding-left: 16px;
                }
            }
        }
    }
    .vline {
        width: 1px;
        background-color: var(--n-grey-2);
    }
    .hline {
        height: 1px;
        background-color: var(--n-grey-2);
    }
    .goods-double {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 0 0.75rem 0;
        .hline {
            height: 1px;
            background-color: var(--n-grey-2);
        }
        .good-main {
            flex-grow: 1;
            text-decoration: none;
            color: inherit;
            display: flex;
            padding: 0.75rem 0.25rem 0.75rem 0;
        }
    }
    
    .good-image{
        margin: auto 1rem;
        display: block;
        position: relative;
        height: 116px;
        /* height: calc(100% - 22.54%); */
        /* padding: 11.27% 4.72%; */
        /* height: min-content; */
    }
    .good-data {
        flex-grow: 1;
        padding: 0 1rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
    }
    .good-desc{
        font-weight: 400;
        text-align: right;
        font-size: 1rem;
        color: #5E5E5E;
    }
    .shop-info{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 0;
        width: calc(100% - 11.64%);
        .shop-logo{
            border: 1px solid var(--n-grey-2);
            width: 2.5rem;
            border-radius: 50px;
        }
        .shop-name{
            font-weight: 400;
            font-size: 0.9rem;
            color: var(--n-grey-7);
            margin-right: 1rem;
        }
    }
    .line{
        border-bottom: 1px solid var(--n-grey-2);
        width: 100%;
    }
    .good-price{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        text-align: left;
        font-weight: 700;
        font-size: 1.5rem;
        padding: 0;
        gap: 0.3rem;
        .price {
            font-size: 1.5rem;
        }

    }
    @media screen and (max-width: 850px){
        flex-direction: column;
        padding: 0;
        .selector {
            flex-direction: row;
            justify-content: flex-start;
            padding: 0.75rem;
        }
        .good-data {
            padding: 0.5rem;
            gap: 0.5rem;
        }
        .good-image{
            margin: auto 0.5rem;
            display: block;
            position: relative;
            height: 100px;
        }
        .shop-info{
            .shop-logo{
                width: 1.5rem;
            }
            .shop-name{
                font-size: 0.8rem;
            }
        }
        .good-price{
            font-weight: 700;
            font-size: 1.1rem;
            gap: 0.2rem;
            .price {
                font-size: 1.1rem;
            }
        }
    }
`



const GoodCartWithSelectorDouble =({data1, data2, selected, onChange=() => {}})=>{
    const makeGood = (data) => {
        let link1 = data.link.replace("https://luxinlux.com", "");
        if(window.innerWidth < 850){
            return (
                <Link to={link1} className="good-main">
                    <img className="good-image" src={data.image} alt={data.name}/>
                    <div className="good-data">
                        <div className="good-desc">
                            {data.name}    
                        </div>
                        <div className="good-price">
                            {formatPrice(data.price)}    
                            <div className="price">تومان</div>
                        </div>
                        <div className="line"></div>
                        <div className="shop-info">
                            <img className="shop-logo" src={data.shopImage} alt={data.shop}/>
                            <span className="shop-name">{data.shop}</span>
                        </div>
                    </div>
                </Link>
            )
        } else {
            return (
                <Link to={link1} className="good-main">
                    <img className="good-image" src={data.image} alt={data.name}/>
                    <div className="good-data">
                        <div className="good-desc">
                            {data.name}    
                        </div>
                        <div className="shop-info">
                            <img className="shop-logo" src={data.shopImage} alt={data.shop}/>
                            <span className="shop-name">{data.shop}</span>
                        </div>
                    </div>
                    <div className="good-price">
                        {formatPrice(data.price)}    
                        <div className="price">تومان</div>
                    </div>
                </Link>
            )
        }
        
    }

    const makeGoods = () => {
        let goods = [];
        if(data1.gCode){
            goods.push(makeGood(data1));
        }
        if(data2.gCode){
            goods.push(<div className="hline"></div>);
            goods.push(makeGood(data2));
        }
        return goods
    }
    return (
        <CartStyle>
            <div className="selector">
                <div className={"button " + ((selected) ? "active" : "")}>
                    <Checkbox 
                        type="checkbox" 
                        className="goods-checkbox"
                        id={"good-double"} 
                        name={"good-double"} 
                        value={"good-double"} 
                        checked={selected} 
                        onChange={onChange}
                        
                    />
                    <label htmlFor={"good-double"}>انتخاب</label>
                </div>
            </div>
            {
                (window.innerWidth < 850) ? (
                    <div className="hline"></div>
                ): (
                    <div className="vline"></div>
                )
            }
            <div className="goods-double">
                {makeGoods()}
            </div>
        </CartStyle>
    )
}
export default GoodCartWithSelectorDouble;